import client from "./axiosConfig";

export const createProcurementGRN = (data) => {
    const config = {
        url: `/procurement/grn/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getProcurementGRN = (params) => {
    const config = {
        url: `/procurement/grn/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const getProcurementGRNMaterials = (params, grn_id) => {
    const config = {
        url: `/procurement/grn/${grn_id}/materials/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const addProcurementGRNMaterials = (data, grn_id) => {
    const config = {
        url: `/procurement/grn/${grn_id}/materials/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getProcurementGRNById = (id) => {
    const config = {
        url: `/procurement/grn/${id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const updateProcurementGRN = (id, data) => {
    const config = {
        url: `/procurement/grn/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const deleteProcurementGRNById = (id) => {
    const config = {
        url: `/procurement/grn/${id}/`,
        method: "DELETE",
    };
    const response = client(config);
    return response;
};

export const getProcurementMRR = (params) => {
  const config = {
    url: `/procurement/mrr/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;
};

export const deletePGRNFileById = (id, file) => {
  const config = {
    url: `/procurement/grn/${id}/delete-invoice/`,
    method: "DELETE",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: file,
  };
  const response = client(config);
  return response;
};